package com.bikompanion.data.map

import dev.zacsweers.metro.ContributesBinding
import dev.zacsweers.metro.Inject
import com.bikompanion.data.cache.LocalStore
import com.bikompanion.data.cache.cacheKey
import com.bikompanion.domain.MapLayerMode
import com.bikompanion.domain.MapLayerPreferencesRepository
import com.bikompanion.domain.di.AppScope

private const val MapLayerModeKey = "map_layer_mode"

/** Stored by enum name; anything unrecognised (a renamed entry, a corrupt write) falls back to [MapLayerMode.Stations]. */
@ContributesBinding(AppScope::class)
@Inject
class MapLayerPreferencesRepositoryImpl(
    private val store: LocalStore,
) : MapLayerPreferencesRepository {
    override fun getMapLayerMode(): MapLayerMode {
        val stored = store.read(cacheKey(MapLayerModeKey)) ?: return MapLayerMode.Stations
        return MapLayerMode.entries.firstOrNull { it.name == stored } ?: MapLayerMode.Stations
    }

    override fun setMapLayerMode(mode: MapLayerMode) {
        store.write(cacheKey(MapLayerModeKey), mode.name)
    }
}
